<template>
  <div class="common-layout" :class="{ 'is-public-page': fullBleedMain }">
    <el-container direction="vertical">
      <TopNav v-if="showTopNav" />
      <el-main class="app-main" :class="{ 'app-main-public': fullBleedMain }">
        <RouterView v-slot="{ Component }">
          <KeepAlive :include="keepAliveIncludes" :key="keepAliveKey">
            <component :is="Component" />
          </KeepAlive>
        </RouterView>
      </el-main>
    </el-container>
  </div>
  
</template>

<script>
import { mapStores } from 'pinia'
import TopNav from '@/components/top_nav.vue'
import { useUserStore } from '@/stores/user'
export default {
  name: 'App',
  components: { TopNav },
  computed: {
    ...mapStores(useUserStore),
    keepAliveIncludes() {
      return ['HomeIndex', 'AiDrawPage', 'AiWorkflowPage']
    },
    keepAliveKey() {
      return this.userStore.token || 'anonymous'
    },
    isPublicPage() {
      const publicNames = ['portal', 'portal-features', 'portal-solutions', 'portal-about', 'login', 'register']
      return publicNames.includes(this.$route.name)
    },
    hideTopNav() {
      return this.$route.meta.hideTopNav === true
    },
    fullBleedMain() {
      return this.isPublicPage || this.hideTopNav
    },
    showTopNav() {
      return !this.isPublicPage && !this.hideTopNav
    }
  }
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  html, body{
    height: 100vh;
    overflow: auto;
    margin: 0;
    padding: 0;
    position: relative;
    width: 100%;
  }
  #app{
    min-height: 100vh;
    overflow: auto;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  :root{
    --bg: #f6f8fb;
    --sidebar-bg: #ffffff;
    --card-bg: #ffffff;
    --text: #0f172a;
    --muted: #6b7280;
    --border: #e5e7eb;
    --accent: #3d55ec; /* 与你已设置的 hover 蓝色一致 */
    --accent-2: #7b8cff;
    --active: #ff932f; /* 与你已设置的激活橙色一致 */
    --shadow-sm: 0 1px 2px rgba(16, 24, 40, .06);
    --shadow-md: 0 8px 24px rgba(16, 24, 40, .08);
    --header-height: 60px;
  }

  body{
    background: var(--bg);
    color: var(--text);
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,"PingFang SC","Microsoft YaHei",sans-serif;
  }

  .common-layout{
    height: 100vh;
    width: 100%;
    background: var(--bg);
    overflow: hidden;
    position: relative;
  }
  .el-container{
    height: 100vh;
    width: 100%;
    overflow: hidden !important;
    box-sizing: border-box;
    position: relative;
    direction: "vertical"
  }

  .top-nav{
    height: var(--header-height);
    background: #ffffff;
    box-shadow: var(--shadow-sm);
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  .nav-content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .brand{
    font-weight: 800;
    font-size: 16px;
    letter-spacing: .3px;
    cursor: pointer;
    padding-left: 4px;
  }

  .top-menu{
    border-bottom: none;
    background: transparent;
  }

  .app-main{
    padding: 0 !important;
    margin: 0 !important;
    background: var(--bg);
    height: calc(100vh - var(--header-height)) !important;
    max-height: calc(100vh - var(--header-height)) !important;
    overflow: hidden;
    box-sizing: border-box;
    width: 100%;
    position: relative;
  }

  .common-layout.is-public-page {
    height: auto;
    min-height: 100vh;
    overflow: visible;
    background: #fff;
  }

  .common-layout.is-public-page .el-container {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  .app-main.app-main-public {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
    background: #fff;
  }
</style>
